import React, { useState } from "react";
import { ModalActions } from "./modalActions";
import PopupModal from "./popupModal";
import { saveUserRating } from "../../services/domainService";
import { useDispatch, useSelector } from "react-redux";
import { launchPadLayoutActions } from "@sf-launchpad";
import { MODAL_TYPES } from "../../constants/modalTypes";
import { getAcademyUrl, getJobUrl, getCourseUrl } from "../../constants/urls";
import { saveCourseTrack } from "../../services/courseService";
import { useNavigate } from "react-router-dom";

const commonLabels = {
  feedback: "modal.feedback",
  buttonRate: "modal.rateFinishButton",
};

// Labels for the different types of modals
const modalState = {
  SkillPath: {
    labels: {
      title: "modal.skillpathCompletion.title",
      message: "modal.skillpathCompletion.message",
      rating: "modal.skillpathCompletion.rating",
      buttonShare: "modal.skillpathCompletion.shareOnLinkedinButton",
      buttonCertificate: "modal.skillpathCompletion.downloadCertficateButton",
      ...commonLabels,
    },
  },
  Content: {
    labels: {
      title: "modal.courseCompletion.title",
      message: "modal.courseCompletion.message",
      rating: "modal.courseCompletion.rating",
      progressSkillspathMessage:
        "modal.courseCompletion.progressSkillspathMessage",
      progressDomainMessage: "modal.courseCompletion.progressJobMessage",
      progressLabel: "modal.courseCompletion.progressLabel",
      buttonClose: "modal.courseCompletion.closeButton",
      nextLabel: "modal.courseCompletion.nextLabel",
      buttonNext: "modal.courseCompletion.nextCourseButton",
      ...commonLabels,
    },
  },
  Domain: {
    labels: {
      title: "modal.domainCompletion.title",
      message: "modal.domainCompletion.message",
      rating: "modal.domainCompletion.rating",
      ...commonLabels,
    },
  },
};

const CompletionModal = ({
  modal,
  populateSkillpathModal,
  populateDomainModal,
  setModal,
}) => {
  const [rating, setRating] = useState(null);
  const [feedbackText, setFeedbackText] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getVideoUrl = useSelector((state) => state.session.tenantSettings);
  const labels = modalState[modal.type]?.labels;
  const backgroundVideo =
    modal.type === MODAL_TYPES.CONTENT
      ? getVideoUrl?.popupCelebrationThumbnails?.courseCompletion
      : getVideoUrl?.popupCelebrationThumbnails?.domainCompletion;

  const submitRating = () => {
    const data = {
      entityId: modal.id,
      entityType: modal.type,
      rating,
      feedback: feedbackText || null,
    };
    saveUserRating(data);
  };

  // When the user closes the completion modal check what type of modal is and remove it from the array
  const popupClose = (nextCourse = false) => {
    setRating(null);
    setFeedbackText("");
    switch (modal.type) {
    case MODAL_TYPES.CONTENT:
      // If the modal is a course remove it from the pending courses array
      dispatch(
        launchPadLayoutActions.updatePendingCompletedCourse({
          courseId: modal.id,
          pending: false,
        })
      );
      // Then check if it was the last course of the skillpath or job domain show the completion modal for the skillpath or job domain
      if (modal.completedCourses === modal.totalCourses) {
        if (modal.isAcademyCourse) populateSkillpathModal(modal.skillPathId);
        else populateDomainModal(modal.domainId);
      } else {
        // If the Next course button was clicked navigate to the next course
        if (nextCourse) {
          // Request to track the skillPath id from where the course was accessed
          let data = {
            skillPathId: modal.nextCourseSkillPathId,
            contentId: modal.nextCourseId,
          };
          saveCourseTrack(data);
          navigate(getCourseUrl(modal.nextCourseId));
        } else {
          // Else navigate to academy or job page depending on the type of course
          if (modal.isAcademyCourse) navigate(getAcademyUrl(modal.domainId));
          else navigate(getJobUrl(modal.domainId));
        }
        setModal({ open: false });
      }
      break;

    case MODAL_TYPES.SKILLPATH:
      // If the modal is a skillpath remove it from the pending skillpaths array and navigate to academy page
      dispatch(
        launchPadLayoutActions.updatePendingCompletedSkillpath({
          skillpathId: modal.id,
          pending: false,
        })
      );
      navigate(getAcademyUrl(modal.domainId));
      setModal({ open: false });
      break;

    case MODAL_TYPES.DOMAIN:
      // If the modal is a job domain remove it from the pending jobs array and navigate to job page
      dispatch(
        launchPadLayoutActions.updatePendingCompletedJobDomain({
          domainId: modal.id,
          pending: false,
        })
      );
      navigate(getJobUrl(modal.id));
      setModal({ open: false });
      break;
    default:
      break;
    }
  };

  return (
    <PopupModal
      backgroundVideo={backgroundVideo || ""}
      labels={labels || {}}
      modal={modal}
      popupClose={popupClose}
      modalActions={
        <ModalActions
          modal={modal}
          labels={labels}
          submitRating={submitRating}
          feedbackText={feedbackText}
          setFeedbackText={setFeedbackText}
          popupClose={popupClose}
        />
      }
      rating={rating}
      setRating={setRating}
    />
  );
};

export default CompletionModal;